import { render, staticRenderFns } from "./AdvertisementsAmount.vue?vue&type=template&id=186e69af&"
import script from "./AdvertisementsAmount.vue?vue&type=script&lang=js&"
export * from "./AdvertisementsAmount.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementsAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports